export default __webpack_public_path__ + "static/media/ce-post1.2d8b3f5d.png";